export class Address {
    public readonly presentation: string;
    public readonly kladr: string;

    constructor(dto?: IAddressDto)
    constructor(
        presentation?: string,
        kladr?: string,
    )
    constructor(
        presentationOrDto: string | IAddressDto = "",
        kladr: string = "",
    ) {
        if (typeof presentationOrDto !== "string") {
            this.presentation = presentationOrDto.unrestricted_value || "";
            this.kladr = presentationOrDto.data.kladr_id || "";
        } else {
            this.presentation = presentationOrDto;
            this.kladr = kladr;
        }
    }
}

export interface IAddressDto {
    readonly data: {
        readonly kladr_id?: string;
    };
    readonly unrestricted_value?: string;
}
